(function () {
  'use strict';

  var cfg = window.qnAoConfig || {};
  var current = { bottle: 1, qty: 1, disc: 0 };
  var prices = { 1: cfg.bottle1Price || 1990, 2: cfg.bottle2Price || 3290 };
  var names = { 1: cfg.bottle1Name || 'Bidón 3L', 2: cfg.bottle2Name || 'Bidón 5L' };

  function calc() {
    var base = prices[current.bottle];
    var subtotal = base * current.qty;
    var total = Math.round(subtotal * (1 - current.disc / 100));
    var saving = subtotal - total;

    var priceEl = document.getElementById('qnAoPriceVal');
    var unitEl = document.getElementById('qnAoPriceUnit');
    var savingsEl = document.getElementById('qnAoSavings');
    var savingsValEl = document.getElementById('qnAoSavingsVal');

    if (priceEl) {
      priceEl.textContent = '$' + total.toLocaleString('es-UY');
    }

    if (unitEl) {
      var qty = current.qty;
      unitEl.textContent = qty + (qty > 1 ? ' bidones' : ' bidón') + ' · ' + names[current.bottle];
    }

    if (savingsEl && savingsValEl) {
      if (saving > 0) {
        savingsEl.classList.remove('hidden');
        savingsValEl.textContent = '$' + saving.toLocaleString('es-UY');
      } else {
        savingsEl.classList.add('hidden');
      }
    }
  }

  window.qnAoSelectBottle = function (n) {
    current.bottle = n;

    var b1 = document.getElementById('qnAoB1');
    var b2 = document.getElementById('qnAoB2');

    if (b1) b1.classList.toggle('active', n === 1);
    if (b2) b2.classList.toggle('active', n === 2);

    calc();
  };

  window.qnAoPickTier = function (el) {
    document.querySelectorAll('.qn-ao-tier').forEach(function (t) {
      t.classList.remove('active');
    });

    el.classList.add('active');
    current.qty = parseInt(el.getAttribute('data-qty'), 10);
    current.disc = parseInt(el.getAttribute('data-disc'), 10);

    calc();
  };

  document.addEventListener('DOMContentLoaded', function () {
    calc();
  });

  if (document.readyState !== 'loading') {
    calc();
  }

})();